import React from 'react';
const AppContext = React.createContext(null);


const DispatchContext = React.createContext(null);
export { AppContext,  DispatchContext };